import { observer } from 'mobx-react';
import * as React from 'react';
import { isReadonly, StringField } from '../../Types';
import clsx from 'clsx';

interface Props {
  field: StringField;
  onChange: (value: string) => void;
}

const errorClassName = (field: StringField): string =>
  field.errors.length > 0 ? 'border-2 border-red-300 border-solid block rounded-md' : '';

const isDisabled = (field: StringField): boolean => isReadonly(field);

const SingleLine: React.FC<Props> = ({ field, onChange }) => (
  <input
    type="text"
    id={field.name}
    className={clsx(
      'w-full rounded-md border border-solid border-gray-300',
      'mb-1 px-4 py-2.5 text-normal text-gray-700',
      errorClassName(field),
    )}
    placeholder={field.placeholder.getOrElseValue('')}
    onChange={(e) => onChange(e.target.value)}
    disabled={isDisabled(field)}
    value={field.value}
    maxLength={field.maxlength}
    minLength={field.minlength.getOrElseValue(0)}
    pattern={field.pattern.map<string | undefined>((r) => r.source).getOrElseValue(undefined)}
    data-intercom-target={`${field.name.replace(/_/g, '-')} input-field`}
  />
);

export default observer(SingleLine);
